const feedback = {
  scheduleSellableStudentExam: {
    genericError: 'Erro ao agendar simulado.',
    itemAlreadyExist: 'Já existe um ‘item’ cadastrado com o nome do simulado.',
    success: 'Simulado agendado com sucesso.',
    invalidProductId: 'Produto informado não é válido.',

  },
  recalculateScoresSellableStudentExams: {
    genericError: 'Erro ao recalcular ranking.',
  },
  editSellableStudentExamError: 'Erro ao editar simulado.',
  editSellableStudentExamSuccess: 'Simulado editado com sucesso.',
  registerSellableStudentExamErrors: {
    userNotFound: 'Autor do simulado não encontrado.',
    generic: 'Erro ao buscar simulado.',
    studentExamNotFound: 'Simulado não encontrado.',
    authorNotPermission: 'Autor do simulado não tem permissão.',
  },
  showAnswersKeysDateTimeError: 'A data de exibição do gabarito não pode ser menor que a data de encerramento do simulado.',
  endDateTimeError: 'A data de encerramento do simulado não pode ser menor que a data de início.',
  getAuthorFullNameErrors: {
    userNotFound: 'Autor do simulado não encontrado.',
    requestError: 'Erro Ao buscar autor.',
  },
  fetchSellableStudentExams: {
    error: 'Erro ao buscar simulados avulsos.',
    empty: 'Nenhum simulado avulso criado ainda.',
  },
};

const CREATE = 'CREATE';
const EDIT = 'EDIT';

export {
  feedback,
  CREATE,
  EDIT,
};
